<template>
  <div>
    <title>单号采集列表</title>
     <section class="orderSect">
      <!--S 检索-->      
      <el-form :inline="true" :model="collectForm">
        <el-form-item label="订单号" class="codeSerIpt">
          <el-input  v-model="collectForm.orderno" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="收货人">
            <el-input  v-model="collectForm.Name" placeholder="请输入收货人" clearable></el-input>
          </el-form-item>
        <el-form-item label="手机号">
            <el-input  v-model="collectForm.phone" placeholder="请输入手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="对照码">
          <el-input  v-model="collectForm.referenceCode" placeholder="请输入对照码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPrintList">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="$router.back(-1)">返回</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="saveExpressno()">保存</el-button>
        </el-form-item>
      </el-form>
      <!--E 检索-->

      <!--S 快递打印列表-->
      <div class="allOrderTab individualiz">
        <el-table v-loading="loading" :data="collectListData" ref="expressTable" class="orderTable comTable" border :maxHeight="tableHeight">       
          <el-table-column type="index" label="序号" fixed width="60"></el-table-column>
          <el-table-column label="对照码" fixed prop="expid" sortable min-width="130">
            <template slot-scope="scope">
              <p>{{scope.row.expid}}</p>
            </template>
          </el-table-column>
          <el-table-column label="快递内容" fixed min-width="350" prop="expcontent" sortable>
            <template slot-scope="scope">
              <small>订单号：{{scope.row.eorderno}}</small>
              <p class="textFl" :title="scope.row.expcontent">{{scope.row.expcontent}}</p>
            </template>
          </el-table-column>
          <el-table-column label="快递单号" min-width="250">
            <template slot-scope="scope">
              <el-input maxlength="20" v-model="scope.row.expno" @input="replaceBlank(scope.row)" placeholder="请输入快递单号" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="快递方式" min-width="250" v-if="nonOddCollection == true || nonOddCollection == 'true'">
            <template slot-scope="scope">
              <el-select v-model="scope.row.exptype" filterable placeholder="请选择或输入" clearable>
                <el-option v-for="(item,index) in expressWayList" :key="index" :label="item.label" :value="item.value"
                :title="item.label">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="收货信息" min-width="350" prop="fulladdr" sortable>
            <template slot-scope="scope">
              <div class="shouMsg">
                <em v-if="scope.row.receivername">{{scope.row.receivername}}</em>
                <em v-if="scope.row.receivertel">{{scope.row.receivertel}}</em>
              </div>              
              <p v-if="scope.row.fulladdr" class="greyColor textFl" :title="scope.row.fulladdr">{{scope.row.fulladdr}}</p>
            </template>
          </el-table-column>
          <el-table-column label="发货状态" min-width="150" prop="deliverstate" sortable>
            <template slot-scope="scope">
              <span :class="[{'blueColor':scope.row.deliverstate==1 || scope.row.deliverstate==3},{'orangeColor':scope.row.deliverstate==0},{'redColor':scope.row.deliverstate==2 || scope.row.deliverstate==6},{'greyColor':scope.row.deliverstate==4},{'greenColor':scope.row.deliverstate==5}]">{{scope.row.deliverstate | deliverStateFilter}}</span>
            </template>
          </el-table-column>
          <el-table-column label="打印状态" min-width="150" prop="bprint" sortable>
            <template slot-scope="scope">
              <span class="orangeColor" v-if="scope.row.bprint == 0&&scope.row.deliverstate!=1&&scope.row.deliverstate!=5&&scope.row.deliverstate!=6">待打印</span>
              <span class="orangeColor" v-else-if="scope.row.bprint == 0">--</span>
              <span class="blueColor" v-if="scope.row.bprint == 1">已打印</span>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="noData"><span>暂无数据</span></div>
          </template>
        </el-table>
      </div>
    <!--E 快递列表-->
    </section>

    <!--S 完善快递弹窗组件-->
    <ImproveExpress :improveExpressBox="improveShow" :collectedShow="collected" @closeIEVal="clsBtnVal" @closeIEBox="closeImproveExpress"></ImproveExpress>
    <!--E 完善快递弹窗组件-->

  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import api from '../../apis/api';
export default {
  name: 'AddExpress',
  data () {
    return {
      collectForm:{
        orderno: "", //订单号
        Name: "", //收货人
        phone: "", //手机号
        referenceCode: "", //对照码
      },
      expressWayList: [],//快递方式列表
      collectListData: [
        {expno: ''}
      ],//打印列表数据
      nonOddCollection: false, //非单号采集
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      improveShow:false, //完善快递的弹窗
      improveEprBtnVal:'',//关闭完善快递弹窗是确定还是取消
      collected:false,//是否展示快递方式
      expgenbatchnoArr: [],//快递批次编号数组
      loading: true,//加载遮罩
      expcodeArr: [],//快递编号数组
      expnoArr: [],//快递单号数组
      exptypeArr: [],//快递方式数组
    }
  },
  components: {
    ImproveExpress: resolve => require(["@/components/DeliveryFolder/ImproveExpress.vue"], resolve), //完善快递组件
  },
  methods: {
    //保存快递单号
    saveExpressno(){
      this.expcodeArr = []
      this.expnoArr = []
      this.exptypeArr = []
      let flag = true
      //校验/构造参数
      this.collectListData.some(item => {
        if(item.expno) {
          //校验快递单号
          let test = /^[0-9a-zA-Z]*$/
          if (!test.test(item.expno)) {
            this.$message.error('非法快递单号，快递单号由字母和数字组成！')
            flag = false
            return true
          }
          this.expnoArr.push(item.expno)
          this.exptypeArr.push(item.exptype)
          this.expcodeArr.push(item.expcode)
        }
      })

      if(!flag) {
        return false
      }
      if(this.expnoArr[0] == '' || this.expnoArr[0] == null) {
        this.$message.error('请至少完善一个快递单号！')
        return false
      }
      this.improveShow = true;
    },
    //关闭完善快递是确定还是取消
    clsBtnVal(val){
      this.improveEprBtnVal = val;
    },
    //关闭完善快递弹窗
    closeImproveExpress(val){
      this.improveShow = false; //完善快递弹窗
      if(Number(this.improveEprBtnVal)){
        //单号采集
        this.updateExpnoCollect(val)
      }
    },

    replaceBlank(val) {
      val.expno = val.expno.replace(/\s*/g,"")
    },
    //单号采集
    updateExpnoCollect(val) {
      this.loading = true
      val = JSON.parse(val)
      let params = {
        expcodeArr: this.expcodeArr,
        expnoArr: this.expnoArr,
        exptypeArr: this.exptypeArr,
        expmoney: val.expressAmount ? val.expressAmount : null,
        issend: val.notice ? 1 : 0,
        sendMsgDate: val.messageDate ? this.dateTime(val.messageDate,1) : null
      }
      //调用单号采集接口
      api.UPDATEEXPNOCOLLECT(params).then(res => {
        if(res.data.status == '200') {
          Message({
            type: 'success',
            message: '单号采集完毕!'
          });
          this.getPrintList()
        } else {
          Message({
            type: 'error',
            message: res.data.message
          });
        }
        this.loading = false
      })
    },

    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.expressTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 70;
    },

    //获取批次快递详情
    getPrintList() {
      this.loading = true
      let params = {
        expgenbatchnoArr: this.expgenbatchnoArr,
        orderno: this.collectForm.orderno,
        receivername: this.collectForm.Name,
        receivertel: this.collectForm.phone,
        expid: this.collectForm.referenceCode,
        printType: 1000
      }
      api.FINDBATCHPRINT(params).then(res => {
        if(res.data.status == '200') {
          this.collectListData = res.data.data.list
          this.expmerge = res.data.data.expmerge
        } else {
          this.collectListData = []
        }
        this.loading = false
      })
    },

    //获取所有的可用快递方式
    getAllExpTypes() {
      if(localStorage.getItem("exptypes")){
        this.expressWayList = []
        let expmodeMap = JSON.parse(localStorage.getItem("exptypes"))
        let newKey = Object.keys(expmodeMap).sort(function(a,b) {
          return a-b;
        });
        for(let i=0; i<newKey.length; i++) {
          this.expressWayList.push({label: expmodeMap[newKey[i]], value: Number(newKey[i])});
        }
      } else {
        api.GET_ALLEXPMODENAMECACHE({}).then(res => {
          if(res.data.status == '200') {
            this.expressWayList = []
            let expmodeMap = res.data.data.expmodeMap;
            let newKey = Object.keys(expmodeMap).sort(function(a,b) {
              return a-b;
            });
            for(let i=0; i<newKey.length; i++) {
              this.expressWayList.push({label: expmodeMap[newKey[i]], value: Number(newKey[i])});
            }
            localStorage.setItem("exptypes",JSON.stringify(expmodeMap))
          }
        })
      }
    },

  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    if (this.$route.params.nonOddCollection) {
      this.nonOddCollection = this.$route.params.nonOddCollection
    }
    console.log(this.nonOddCollection)
    if(sessionStorage.getItem('expgenbatchnoArr')) {
      this.expgenbatchnoArr = JSON.parse(sessionStorage.getItem('expgenbatchnoArr'))
    }
    this.getAllExpTypes()
    //在dom渲染之后
    setTimeout(() => {
      this.getHeight()
      this.getPrintList()
    }, 200);
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
@import "Css/Style.css";
</style>



// WEBPACK FOOTER //
// src/views/DeliveryFolder/orderCollectionList.vue